// Display formatting helpers. Times render Homebase-style: 7:00am, 2:45pm.
import { DateTime } from 'luxon'
import { TZ } from './time'

export function formatTime(hhmm: string): string {
  const [h, m] = hhmm.split(':').map(Number)
  const suffix = h < 12 ? 'am' : 'pm'
  const hour12 = h % 12 === 0 ? 12 : h % 12
  return `${hour12}:${String(m).padStart(2, '0')}${suffix}`
}

export function formatTimeRange(startTime: string, endTime: string, endsNextDay: boolean): string {
  return `${formatTime(startTime)}–${formatTime(endTime)}${endsNextDay ? ' +1d' : ''}`
}

export function formatHours(h: number): string {
  return Number.isInteger(h) ? `${h}h` : `${h.toFixed(2).replace(/0$/, '')}h`
}

export function formatDateLong(date: string): string {
  return DateTime.fromISO(date, { zone: TZ }).toFormat('cccc, LLLL d')
}

export function formatDateShort(date: string): string {
  return DateTime.fromISO(date, { zone: TZ }).toFormat('ccc L/d')
}

export function formatWeekRange(weekStart: string): string {
  const start = DateTime.fromISO(weekStart, { zone: TZ })
  const end = start.plus({ days: 6 })
  const sameMonth = start.month === end.month
  return sameMonth
    ? `${start.toFormat('LLLL d')} – ${end.toFormat('d, yyyy')}`
    : `${start.toFormat('LLLL d')} – ${end.toFormat('LLLL d, yyyy')}`
}

export function initials(displayName: string): string {
  return displayName
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]!.toUpperCase())
    .join('')
}

/** "Riley C." — the Homebase grid label form. */
export function shortName(displayName: string): string {
  const parts = displayName.split(/\s+/).filter(Boolean)
  if (parts.length < 2) return displayName
  return `${parts[0]} ${parts[parts.length - 1]![0]}.`
}
